// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2965":"1f0a81b25cb192f3","6274":"e57f85aa0ed91b0c"}[chunkId] + ".css";
};